import type { Schema } from '../../../Entities/Schema.entity';
import { createSchema } from '../../../Utils/CreateSchema';

export const reservationSubmitDetailsSchema: Schema = {
  ...createSchema({
    version: '1-0-0',
    description: 'Submission of a reserve lead',
    name: 'reserve_submit_details',
    properties: {
      lead_type: {
        type: 'string',
        description: 'The type of lead',
      },
      lead_id: {
        type: 'string',
        description: 'the id of the lead from the backend',
      },
      listing_id: {
        type: 'string',
        description: 'The id of the listing',
      },
    },
    required: ['lead_type', 'lead_id', 'listing_id'],
  }),
};
